/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import Header from '../Components/Header/page'
import Footer from '../Components/Footer/Footer'
import axios from 'axios';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment/moment';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../pages/style.css'
import Form from 'react-bootstrap/Form';
// import { format } from 'date-fns';
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton';
import { Oval } from 'react-loader-spinner';
import ReactSelect from 'react-select';


const Appointment = () => {

    const adminToken = localStorage.getItem('admintoken')
    const [Loader, setLoader] = useState(false)
    const [BarberLoader, setBarberLoader] = useState(false)
    const [ServiceLoader, setServiceLoader] = useState(false)
    const [AddCustomerLoader, SetAddCustomerLoader] = useState(false)
    const [AddAppointmentLoader, SetAddAppointmentLoader] = useState(false)
    const [EditAppointmentLoader, SetEditAppointmentLoader] = useState(false)
    const [CancelAppointment, SetCancelAppointment] = useState(false)
    const [BlockUser, SetBlockUser] = useState(false)
    const [data, setData] = useState([])
    const [Appointment, setAppointment] = useState([])
    const [AllUser, setAllUser] = useState([])
    const [AllBarber, setAllBarber] = useState([])
    const [AllServices, setAllServices] = useState([])
    const [, setGetService] = useState()
    const [FinData, setFinData] = useState()
    const [FindServiceData, setFindServiceData] = useState()
    const [show, setShow] = useState(false);
    // const [, setSelectedDate] = useState(new Date());
    const [, setIndex] = useState(1);
    const [, setService_id] = useState();
    const [, setBarber_id] = useState();
    const [Appointment_id, setAppointment_id] = useState();
    // const [, setUpdateData] = useState();
    const [date, setDate] = useState();
    const [UpdateDate, setUpdateDate] = useState();
    const [Slots, setSlots] = useState();
    // const [, setUpdateTimeSlots] = useState([]);
    const [isModalEditAppointment, setisModalEditAppointment] = useState(true);
    const [UserFirstName, setUserFirstName] = useState("");
    const [UserLastName, setUserLastName] = useState("");
    const [UserEmail, setUserEmail] = useState("");
    const [UserPhone, setUserPhone] = useState("");
    const [Addcustomer, SetAddcustomer] = useState(false);
    const [Error, setError] = useState();
    const [currentView, setCurrentView] = useState('dayGridMonth');
    const [selectedUser, setSelectedUser] = useState(AllUser[1])


    const getbarbervalue = (e) => {
        const barberid = e.target.value;
        getServices(barberid)
        setGetService(barberid)

    }

    const GetServiceValue = (e) => {
        const serviceid = e.target.value;
        const FindService = AllServices?.find((i) => i?.id === Number(serviceid))
        console.log(FindService, "FindService")
        setFindServiceData(FindService)
    }
    const getAppointment = () => {
        const body = {
            method: 'get',
            url: 'https://api.kazbarber.com/api/admin/bookings',
            headers: {
                'Authorization': `Bearer ${adminToken}`,
                'Accept': 'application/json'
            }
        }

        axios(body).then((response) => {
            console.log(response.data, 'appointment');
            setAppointment(response.data)
            const formattedEvents = response?.data?.data?.map((event) => ({
                id: event.id,
                barberid: event?.slot?.service?.barber?.id,
                serviceid: event?.slot?.service?.id,
                title: event?.slot?.service?.title,
                start: moment(`${event?.date} ${event?.slot?.start_time}`, 'YYYY-MM-DD HH:mm').format(),
                end: moment(`${event?.date} ${event?.slot?.end_time}`, 'YYYY-MM-DD HH:mm').format(),
                name: event?.user?.fname,
                lname: event?.user?.lname,
                barber: event?.slot?.service?.barber?.fname,
                Phone: event?.user?.phone,

                // You can include additional event properties here
            }));
            setData(formattedEvents);
        })
            .catch((error) => {
                console.error('Error fetching barber data:', error);
            });
    }

    useEffect(() => {
        getAppointment()
    }, []);

    const getAllBarber = () => {
        setBarberLoader(true)
        try {
            const body = {
                method: 'get',
                url: 'https://api.kazbarber.com/api/admin/barbers',
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }

            axios(body).then((response) => {
                setBarberLoader(false)
                console.log(response.data, 'allbarber');
                setAllBarber(response?.data?.data)
            })
                .catch((error) => {
                    setBarberLoader(false)
                    console.error('Error fetching barber data:', error);
                });
        } catch (error) {
            setBarberLoader(false)
        }
    }

    const getAlluser = () => {
        setLoader(true)
        try {
            const body = {
                method: 'get',
                url: 'https://api.kazbarber.com/api/admin/users',
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }

            axios(body).then((response) => {
                setLoader(false)
                console.log(response.data, 'allUser');
                setAllUser(response?.data?.data)
            })
                .catch((error) => {
                    setLoader(false)
                    console.error('Error fetching barber data:', error);
                });
        } catch (error) {
            setLoader(false)
        }
    }

    const getServices = (barberid) => {
        setServiceLoader(true)
        try {
            const body = {
                method: 'get',
                url: `https://api.kazbarber.com/api/admin/barbers/${barberid}/services?date=${UpdateDate}`,
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }

            axios(body).then((response) => {
                setServiceLoader(false)
                console.log(response.data, 'allServices');
                setAllServices(response?.data?.data)
            })
                .catch((error) => {
                    setServiceLoader(false)
                    console.error('Error fetching barber data:', error);
                });
        } catch (error) {
            setServiceLoader(false)
        }
    }
    const cancelAppointment = () => {
        SetCancelAppointment(true)
        try {
            const body = {
                method: 'delete',
                url: `https://api.kazbarber.com/api/admin/bookings/${Appointment_id}`,
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }

            axios(body).then((response) => {
                SetCancelAppointment(false)
                console.log(response, 'cancel');
                toast.success('appointment cancel Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                handleClose()
                setisModalEditAppointment(true)
                getAppointment();
            })
                .catch((error) => {
                    SetCancelAppointment(false)
                    console.error('Error fetching barber data:', error);
                });
        } catch (error) {
            SetCancelAppointment(false)
        }
    }
    const blockappointment = (userId) => {
        SetBlockUser(true)
        try {
            const body = {
                method: 'PUT',
                url: `https://api.kazbarber.com/api/admin/users/${userId}/active_deactive`,
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }

            axios(body).then((response) => {
                SetBlockUser(false)
                console.log(response, 'block');
                toast.success('Block User Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                handleClose()
                setisModalEditAppointment(true)
                getAppointment();
            })
                .catch((error) => {
                    SetBlockUser(false)
                    console.error('Error fetching barber data:', error);
                });
        } catch (error) {
            SetBlockUser(false)
        }
    }

    const chooseDate = (barber_id, serviceid, appointmentid) => {
        const FindData = Appointment?.data?.find((e) => e?.id === Number(appointmentid))
        console.log(FindData, "FindData")
        setFinData(FindData)
        getAllBarber();
        setShow(true);
        setBarber_id(barber_id)
        setService_id(serviceid)
        setAppointment_id(appointmentid)
    }
    const handleClose = () => {
        setShow(false)
        setisModalEditAppointment(true)
        setIndex(1)
    }


    const handleUpdate = () => {
        SetEditAppointmentLoader(true)
        try {
            const data = new URLSearchParams();
            data.append('slot_id', Slots ? Slots : FinData?.slot?.id)
            data.append('date', UpdateDate ? UpdateDate : FinData?.date)
            const body = {
                method: 'PUT',
                data: data,
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }
            axios(`https://api.kazbarber.com/api/admin/bookings/${Appointment_id}`, body).then((response) => {
                console.log(response, "barbar")
                if (response?.data?.status) {
                    SetEditAppointmentLoader(false)
                    toast.success('appointment Update Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    handleClose()
                    getAppointment()
                } else {
                    console.log(response, "error")
                    SetEditAppointmentLoader(false)
                }
            })

        } catch (error) {
            console.log(error)
            SetEditAppointmentLoader(false)
        }

    }
    const handleAdd = () => {
        SetAddAppointmentLoader(true)
        try {
            const data = new FormData();
            data.append('slot_id', Slots)
            data.append('date', UpdateDate)
            data.append('user', selectedUser?.value)
            const body = {
                method: 'POST',
                data: data,
                headers: {
                    'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }
            axios(`https://api.kazbarber.com/api/admin/book`, body)
                .then((response) => {
                    console.log(response, "appoint")
                    if (response?.data?.status) {
                        SetAddAppointmentLoader(false)
                        toast.success('appointment Add Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        handleClose()
                        setisModalEditAppointment(true)
                        getAppointment();

                    } else {
                        console.log(response, "error")
                        SetAddAppointmentLoader(false)
                        toast.success('appointment Add Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        handleClose()
                        setisModalEditAppointment(true)
                    }
                }).catch((error) => {
                    console.log(error, "er")
                    setError(error?.response?.data?.errors)
                    SetAddAppointmentLoader(false)
                })

        } catch (error) {
            console.log(error, "err")
            const err = Object.keys(error?.response?.data?.errors)
            setError(err, "err")


        }

    }
    const handleAddcustomer = () => {
        SetAddCustomerLoader(true)
        try {
            const data = new FormData();
            data.append('fname', UserFirstName)
            data.append('lname', UserLastName)
            data.append('email', UserEmail)
            data.append('password', "12345678")
            data.append('phone', `+${UserPhone}`)
            const body = {
                method: 'POST',
                data: data,
                headers: {
                    // 'Authorization': `Bearer ${adminToken}`,
                    'Accept': 'application/json'
                }
            }
            axios(`https://api.kaz.dev-iuh.xyz/api/users`, body)
                .then((response) => {
                    console.log(response, "Customer")
                    if (response?.data?.status) {
                        SetAddCustomerLoader(false)
                        toast.success('Add Customer Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        SetAddcustomer(false)
                        getAlluser();
                    } else {
                        SetAddCustomerLoader(false)
                        console.log(response, "error")
                        SetAddcustomer(true)
                    }
                }).catch((error) => {
                    console.log(error, "er")
                    setError(error?.response?.data?.errors)
                    SetAddCustomerLoader(false)
                })

        } catch (error) {
            console.log(error, "er")
            setError(error?.response?.data?.errors)
            SetAddCustomerLoader(false)

        }

    }

    const calendarRef = useRef(null);

    const handleDateClick = (arg) => {

        // console.log(arg, "arg")
        // setDate(arg.dateStr);
        const clickedDate = arg.dateStr;

        if (calendarRef.current) {
            calendarRef.current.getApi().changeView('timeGridDay', clickedDate);
        }
    };
    const handleDateSet = (arg) => {
        console.log(arg.view.type, "check date")
        // Update the date state with the current date displayed in the calendar
        setCurrentView(arg.view.type)
        if (arg.view.type) {
            setDate(arg.view.getCurrentData().dateProfile.currentDate);
        }
    };

    const appointmentModal = () => {
        getAlluser();
        getAllBarber();
        setShow(true);
        setisModalEditAppointment(false)
    }
    // console.log(Error, "Error")


    const viewRender = (view) => {
        setCurrentView(view.view.type);
    };
    console.log(currentView, "currentView")

    const handleChange = (selectedOption) => {
        console.log(selectedOption, "selectedOption")
        setSelectedUser(selectedOption);
    };


    return (
        <>

            <Header />
            <section className='appointment'>
                <div className='container-fluid'>

                    <h1>Appointments</h1>
                    <div className='d-flex justify-content-center align-items-center flex-column'>
                        <h4 className='text-dark fw-bolder'>Add an Appointment on behalf of customer</h4>
                        <button className='my-3 btn btn-outline-dark btn-sm' onClick={() => appointmentModal()}>Add Apoointment</button>
                    </div>


                    <div className="calendar-container">
                        <FullCalendar
                            id="full-calendar"
                            ref={calendarRef}
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}

                            customButtons={{
                                customDateButton: {
                                    text: moment(date).format('MMMM D, YYYY'),
                                }
                            }}
                            headerToolbar={{
                                left: 'prev,next',
                                center: 'customDateButton', // Use your custom button
                                right: 'dayGridMonth,timeGridDay'
                            }}
                            initialDate={date}
                            weekends={true}
                            editable={true}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={true}
                            select={handleDateClick}
                            events={data}
                            viewRender={viewRender}
                            eventContent={(info) => {
                                console.log(info.event, "info")
                                return (

                                    currentView === 'timeGridDay' ? (
                                        <div className="event-custom-style" onClick={() => chooseDate(info.event.extendedProps.barberid, info.event.extendedProps.serviceid, info.event.id)}>

                                            <ul>
                                                <>
                                                    <li>{info.event.title}</li>
                                                    <li>Time: {moment(info.event.start).format('HH:mm')} - {moment(info.event.end).format('HH:mm')}</li>
                                                    <li>Barber Name: {info.event.extendedProps.barber}</li>
                                                    <li>Customer Name: {`${info.event.extendedProps.name}`}</li>
                                                    <li>Customer Contact: {`${info.event.extendedProps.Phone}`}</li>
                                                </>
                                            </ul>
                                        </div>
                                    )
                                        :
                                        <div className="event-custom-style" onClick={() => chooseDate(info.event.extendedProps.barberid, info.event.extendedProps.serviceid, info.event.id)}>
                                            <ul>
                                                <li>{info.event.title}</li>
                                            </ul>
                                        </div>
                                )
                            }}

                            dateClick={handleDateClick}
                            datesSet={handleDateSet}
                            // slotMinTime='09:00:00' // Set the start time for day grid view
                            // slotMaxTime='21:00:00' // Set the end time for day grid view
                            slotDuration='00:05:00'
                            slotLabelInterval='min: 0' // Set the duration for each time slot
                            height='auto'
                            style={{ width: '100%' }} // Set the width to 100%

                        />

                    </div>
                </div>
            </section >
            <Footer />



            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{isModalEditAppointment ? "Update Appointment" : "Add Appointment"}</Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    {isModalEditAppointment ?
                        <Form>
                            <div className='row'>

                                <Button variant="outline-secondary" className="mb-4 w-50 mx-auto" onClick={cancelAppointment}>
                                    {CancelAppointment ?
                                        <Oval
                                            ariaLabel="loading-indicator"
                                            height={50}
                                            width={50}
                                            strokeWidth={1}
                                            strokeWidthSecondary={2000}
                                            color="black"
                                            secondaryColor="black"
                                            wrapperStyle={{ display: 'flex', justifyContent: "center", }}
                                        /> :
                                        "Cancel Appointment"
                                    }
                                </Button>

                                <Form.Group className="col-md-12 mb-3" controlId="formBasicEmail">
                                    <Form.Label className='text-dark '>Date</Form.Label>
                                    <Form.Control type="Date" defaultValue={FinData?.date} onChange={(e) => setUpdateDate(e.target.value)} />
                                </Form.Group>

                                <Form.Label>Select Barber</Form.Label>
                                <Form.Select className="col-md-12 mb-3" onChange={(e) => getbarbervalue(e)} >
                                    {AllBarber?.length < 0 ?
                                        <option >{`${FinData?.slot?.service?.barber?.fname} ${FinData?.slot?.service?.barber?.lname}`}</option>
                                        : null}
                                    {Loader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            {AllBarber?.map((e) => (
                                                <option value={e?.id}>{`${e?.fname} ${e?.lname}`}</option>
                                            ))}
                                        </>
                                    }
                                </Form.Select>
                                <Form.Label>Select Services </Form.Label>
                                <Form.Select className="col-md-12 mb-3" onChange={(e) => GetServiceValue(e)}>
                                    {AllServices?.length == 0 ?
                                        <option >{FinData?.slot?.service?.title}</option>
                                        : null}
                                    {Loader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            {AllServices?.map((e) => (
                                                <option value={e?.id}>{e?.title || <Skeleton />}</option>
                                            ))
                                            }
                                        </>
                                    }
                                </Form.Select>
                                <Form.Label>Select Time Slots</Form.Label>
                                <Form.Select className="col-md-12 mb-3" defaultValue={`${FinData?.slot?.start_time} ${FinData?.slot?.end_time}`} onChange={(e) => setSlots(e.target.value)}>
                                    {AllServices?.length == 0 ?
                                        <option >{`${FinData?.slot?.start_time} ${FinData?.slot?.end_time}`}</option>
                                        : null}
                                    {Loader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            {FindServiceData?.timeslots?.map((e) => (
                                                <option value={e?.id}>{`${e?.start_time} ${e?.end_time}`}</option>
                                            ))
                                            }
                                        </>
                                    }
                                </Form.Select>
                                <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">

                                    <Form.Label>Customer Name</Form.Label>
                                    <br />
                                    <Form.Label>{`${FinData?.user?.fname} ${FinData?.user?.lname}`}</Form.Label>

                                </Form.Group>
                                <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">

                                    <Form.Label>Customer Phone</Form.Label>
                                    <br />
                                    <Form.Label>{FinData?.user?.phone ? FinData?.user?.phone : "No Contact Number"}</Form.Label>




                                </Form.Group>
                                <Button variant="outline-secondary" className="mx-auto w-50" onClick={() => blockappointment(FinData?.user?.id)}>
                                    {BlockUser ?
                                        <Oval
                                            ariaLabel="loading-indicator"
                                            height={50}
                                            width={50}
                                            strokeWidth={1}
                                            strokeWidthSecondary={2000}
                                            color="black"
                                            secondaryColor="black"
                                            wrapperStyle={{ display: 'flex', justifyContent: "center", }}
                                        /> :
                                        "Block this user"
                                    }
                                </Button>
                            </div>
                        </Form>
                        :
                        <Form>
                            <div className='row'>
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <Form.Label>Select Customer</Form.Label>
                                    <Button variant="outline-secondary" onClick={() => SetAddcustomer(true)}>
                                        Add Customer
                                    </Button>
                                </div>
                                {!Addcustomer ?
                                    <>
                                        {/* <Form.Select className="col-md-12 mb-3" onChange={(e) => setUservalue(e.target.value)} >
                                            {Loader ?
                                                <option >Loading ......</option>
                                                :
                                                <>
                                                    <option >Select Customer</option>
                                                    {AllUser?.map((e) => (
                                                        <option value={e?.id}>{`${e?.fname} ${e?.lname}`}</option>
                                                    ))}

                                                   
                                                </>
                                            }
                                        </Form.Select> */}
                                        <ReactSelect
                                            value={selectedUser}
                                            options={AllUser?.map((e) => ({ label: `${e?.fname} ${e?.lname}`, value: e?.id }))}
                                            onChange={handleChange}
                                        />
                                        <Form.Label className='text-danger '>{Error?.user ? Error?.user[0] : null}</Form.Label>
                                    </>
                                    :
                                    <>
                                        <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">
                                            <Form.Label>User First Name</Form.Label>
                                            <Form.Control type="text" value={UserFirstName} onChange={(e) => setUserFirstName(e.target.value)} />
                                            <Form.Label className='text-danger'>{Error?.fname ? Error?.fname[0] : null}</Form.Label>
                                        </Form.Group>
                                        <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">
                                            <Form.Label>User Last Name</Form.Label>
                                            <Form.Control type="text" value={UserLastName} onChange={(e) => setUserLastName(e.target.value)} />
                                            <Form.Label className='text-danger'>{Error?.lname ? Error?.lname[0] : null}</Form.Label>
                                        </Form.Group>
                                        <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">
                                            <Form.Label>User Email</Form.Label>
                                            <Form.Control type="email" value={UserEmail} onChange={(e) => setUserEmail(e.target.value)} />
                                            <Form.Label className='text-danger'>{Error?.email ? Error?.email[0] : null}</Form.Label>
                                        </Form.Group>

                                        <Form.Group className="col-md-6 mb-3" controlId="formBasicUserName">
                                            <Form.Label>User Phone</Form.Label>
                                            <Form.Control type="number" value={UserPhone} onChange={(e) => setUserPhone(e.target.value)} />
                                            <Form.Label className='text-danger'>{Error?.phone ? Error?.phone[0] : null}</Form.Label>
                                        </Form.Group>
                                        <Button variant="outline-secondary" onClick={handleAddcustomer}>
                                            {AddCustomerLoader ?
                                                <Oval
                                                    ariaLabel="loading-indicator"
                                                    height={50}
                                                    width={50}
                                                    strokeWidth={1}
                                                    strokeWidthSecondary={2000}
                                                    color="black"
                                                    secondaryColor="black"
                                                    wrapperStyle={{ display: 'flex', justifyContent: "center" }}
                                                /> :
                                                "Add Customer"
                                            }
                                        </Button>
                                        <Button variant="outline-secondary" className="mt-2" onClick={() => SetAddcustomer(false)}>
                                            Cancel
                                        </Button>
                                    </>
                                }
                                {/* add apointment form*/}
                                <Form.Group className="col-md-12 mb-3" controlId="formBasicEmail">

                                    <Form.Label className='text-dark '>Date</Form.Label>
                                    <Form.Control type="Date" value={UpdateDate} onChange={(e) => setUpdateDate(e.target.value)} />
                                    <Form.Label className='text-danger '>{Error?.date ? Error?.date[0] : null}</Form.Label>


                                </Form.Group>
                                <Form.Label>Select Barber</Form.Label>
                                <Form.Select className="col-md-12 mb-3" onChange={(e) => getbarbervalue(e)} >

                                    {BarberLoader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            <option >Select Barber</option>
                                            {AllBarber?.map((e) => (
                                                <option value={e?.id}>{`${e?.fname} ${e?.lname}`}</option>
                                            ))}
                                        </>
                                    }
                                </Form.Select>
                                <Form.Label>Select Services </Form.Label>
                                <Form.Select className="col-md-12 mb-3" onChange={(e) => GetServiceValue(e)}>
                                    {AllServices.length == 0 ?
                                        <option> Select Barber First</option>
                                        : null}
                                    {ServiceLoader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            <option >Select Service</option>
                                            {AllServices?.map((e) => (
                                                <option value={e?.id}>{e?.title || <Skeleton />}</option>
                                            ))
                                            }
                                        </>
                                    }
                                </Form.Select>
                                <Form.Label>Select Time Slots</Form.Label>
                                <Form.Select className="col-md-12 mb-3" onChange={(e) => setSlots(e.target.value)}>
                                    {AllServices?.length == 0 ?
                                        <option> Select Service First</option>
                                        : null}
                                    {Loader ?
                                        <option >Loading ......</option>
                                        :
                                        <>
                                            <option >Select TIme Slots</option>
                                            {FindServiceData?.timeslots?.map((e) => (
                                                e?.is_available &&
                                                <option value={e?.id}>{`${e?.start_time} ${e?.end_time}`}</option>

                                            ))
                                            }
                                        </>
                                    }
                                </Form.Select>
                                <Form.Label className='text-danger '>{Error?.slot_id ? Error?.slot_id[0] : null}</Form.Label>

                            </div>
                        </Form>
                    }

                </Modal.Body>
                <Modal.Footer>
                    {isModalEditAppointment ?

                        <Button variant="secondary" onClick={handleUpdate}>
                            {EditAppointmentLoader ?
                                <Oval
                                    ariaLabel="loading-indicator"
                                    height={50}
                                    width={50}
                                    strokeWidth={1}
                                    strokeWidthSecondary={2000}
                                    color="black"
                                    secondaryColor="black"
                                    wrapperStyle={{ display: 'flex', justifyContent: "center" }}
                                /> :
                                "    Update"
                            }
                        </Button>
                        :
                        <Button variant="secondary" onClick={handleAdd}>
                            {AddAppointmentLoader ?
                                <Oval
                                    ariaLabel="loading-indicator"
                                    height={50}
                                    width={50}
                                    strokeWidth={1}
                                    strokeWidthSecondary={2000}
                                    color="black"
                                    secondaryColor="black"
                                    wrapperStyle={{ display: 'flex', justifyContent: "center" }}
                                /> :
                                "Add Appointment"
                            }
                        </Button>
                    }

                </Modal.Footer>
            </Modal >
        </>
    )
}



export default Appointment
